import { DialogActions } from "@material-ui/core";
import React from "react";
import { Card } from "react-bootstrap";
import DialogLayout from "../../../../partials/content/DialogLayout";
import SearchJourneyStocks from "../../crm/journey/journeyDetail/searchJourneyStocks";
import SearchItem from "../../inventory/items/searchItem";

function SalesSelectItem({
  journeyID,
  openSearchItemType,
  setOpenSearchItemType,
  setOpenSearchItem,
  setTab,
  openSearchItem,
  values,
  property,
  push,
  tab,
  selectItem,
}) {
  return (
    <React.Fragment>
      <DialogLayout
        open={openSearchItemType}
        title="Select Item Type"
        onCloseDialog={() => {
          setOpenSearchItemType(false);
        }}
        maxWIdth="md"
      >
        <div className="row menu-row-modules mt-4">
          <div className="col-sm-4 col-md-4 col-lg-4">
            <div className="menu-grid-square">
              <Card
                className="card-select-type"
                onClick={() => {
                  setOpenSearchItemType(false);
                  setOpenSearchItem(true);
                  setTab({
                    ID: 1,
                    title: "Sellable Items",
                    icon: "fas fa-boxes",
                  });
                }}
              >
                <Card.Body>
                  <div className="menu-title mb-2">Sellable Items</div>
                  <i className="fas fa-boxes fa-4x"></i>
                </Card.Body>
              </Card>
            </div>
          </div>
          <div className="col-sm-4 col-md-4 col-lg-4">
            <div className="menu-grid-square">
              <Card
                className="card-select-type"
                onClick={() => {
                  setOpenSearchItemType(false);
                  setOpenSearchItem(true);
                  setTab({
                    ID: 2,
                    title: "Services",
                    icon: "fas fa-tools",
                  });
                }}
              >
                <Card.Body>
                  <div className="menu-title mb-2">Services</div>
                  <i className="fas fa-tools fa-4x"></i>
                </Card.Body>
              </Card>
            </div>
          </div>
          <div className="col-sm-4 col-md-4 col-lg-4">
            <div className="menu-grid-square">
              <Card
                className="card-select-type"
                onClick={() => {
                  setOpenSearchItemType(false);
                  setOpenSearchItem(true);
                  setTab({
                    ID: 3,
                    title: "Item Packages",
                    icon: "fab fa-dropbox",
                  });
                }}
              >
                <Card.Body>
                  <div className="menu-title mb-2">Item Packages</div>
                  <i className="fab fa-dropbox fa-4x"></i>
                </Card.Body>
              </Card>
            </div>
          </div>
        </div>
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchItemType(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      {/*  */}
      <DialogLayout
        open={openSearchItem}
        title="Search Item"
        onCloseDialog={() => {
          setOpenSearchItem(false);
          setOpenSearchItemType(true);
        }}
        minHeight={true}
      >
        {journeyID > 0 ? (
          <SearchJourneyStocks
            journeyID={journeyID}
            onSelectStock={(stock) => {
              const salesItemTmp = [...values[property]];
              let stockFound = false;
              for (const salesItem of salesItemTmp) {
                if (salesItem.journeyStockID === stock.ID) {
                  stockFound = true;
                  break;
                }
              }
              if (!stockFound) {
                push({
                  ID: 0,
                  childItem: false,
                  discountPromoID: 0,
                  discountPromoFreeItemID: 0,
                  discountPromoTriggerItemID: 0,
                  journeyStockID: stock.ID,
                  itemID: stock.itemID,
                  varCode: stock.varCode,
                  itemName: stock.itemName,
                  itemPackageID: 0,
                  itemPackageDetailID: 0,
                  qty: 0,
                  stockQty: stock.qty,
                  batchID: stock.batchID,
                  oriQty: 0,
                  currencyID: 0,
                  oriMinimumPrice: stock.item.minimumPrice,
                  minimumPrice: stock.item.minimumPrice,
                  uomID: stock.uomID,
                  uomName: stock.uomName,
                  unitPrice: stock.item.publishPrice,
                  discountPercent: 0,
                  discountAmount: 0,
                  taxPercent: 0,
                  taxAmount: 0,
                  totalPrice: 0,
                  discountPromo: { ID: 0, name: "" },
                  editable: true,
                  deleteInd: false,
                });
              }
              setOpenSearchItem(false);
            }}
          />
        ) : (
          <SearchItem
            tab={tab}
            selectSellableItems={true}
            selectServiceItems={true}
            selectItemPackages={true}
            selectAssetItems={false}
            selectVariant={true}
            onSelectItem={(item, itemPackage, varCode, valueName) => {
              selectItem(item, itemPackage, varCode, valueName);
            }}
          />
        )}
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchItem(false);
              setOpenSearchItemType(true);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
}

export default SalesSelectItem;
